import { Content } from '@prismicio/client';
import { PrismicImage } from '@prismicio/react';

// Components
import { Box, Wrapper } from '@preventx/oxygen';
import { RichTextHero } from '@/components/RichText/RichTextHero';

export type HeroWithBackgroundImageProps = {
  slice: Content.HeroSliceWithBackgroundImage;
};

export const HeroWithBackgroundImage = ({
  slice,
}: HeroWithBackgroundImageProps) => {
  const { primary } = slice;
  const { background_image, title } = primary;

  return (
    <>
      <Wrapper size="lg" className="h-full">
        <Box component="div" className="hero__content">
          <RichTextHero content={title} />
        </Box>
      </Wrapper>
      <Box component="div" className="hero__graphic">
        <figure className="hero-mask">
          <PrismicImage field={background_image} loading="eager" />
        </figure>
      </Box>
    </>
  );
};
